'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logger = require('common/logger');

var _logger2 = _interopRequireDefault(_logger);

var _logoOnlyHeader = require('common/components/headers/logo-only-header');

var _logoOnlyHeader2 = _interopRequireDefault(_logoOnlyHeader);

var _captiveFooter = require('common/components/footers/captive-footer');

var _captiveFooter2 = _interopRequireDefault(_captiveFooter);

var _stripeSecurityCallout = require('./stripe-security-callout');

var _stripeSecurityCallout2 = _interopRequireDefault(_stripeSecurityCallout);

var _titleArea = require('./title-area');

var _titleArea2 = _interopRequireDefault(_titleArea);

var _featureArea = require('./feature-area');

var _featureArea2 = _interopRequireDefault(_featureArea);

var _paymentFormContainer = require('./payment-form-container');

var _paymentFormContainer2 = _interopRequireDefault(_paymentFormContainer);

var _inlineStripeForm = require('./inline-stripe-form');

var _inlineStripeForm2 = _interopRequireDefault(_inlineStripeForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function PaymentArea(p) {

    var enterCardBlurb = _react2['default'].createElement(
        'p',
        null,
        'Enter your credit card information'
    );

    var formProps = {
        targetPlan: p.planData.guid,
        period: p.period
    };

    return _react2['default'].createElement(
        'div',
        { className: 'payment-area' },
        enterCardBlurb,
        _react2['default'].createElement(
            _paymentFormContainer2['default'],
            _extends({}, p, formProps),
            _react2['default'].createElement(_inlineStripeForm2['default'], null)
        )
    );
}

function NoThanksLink(p) {

    var link = '/info/chooseFreeOrEnterpriseSignupPlan';
    var text = 'No thanks, downgrade me to a limited free plan';

    return _react2['default'].createElement(
        'div',
        { className: 'no-thanks-link' },
        _react2['default'].createElement(
            'a',
            { href: link },
            text
        )
    );
}

function CtaArea(p) {
    return _react2['default'].createElement(
        'div',
        { className: 'cta-area' },
        _react2['default'].createElement(PaymentArea, p),
        _react2['default'].createElement(NoThanksLink, null)
    );
}

var PaymentPage = function (_Component) {
    _inherits(PaymentPage, _Component);

    function PaymentPage(p) {
        _classCallCheck(this, PaymentPage);

        var _this = _possibleConstructorReturn(this, (PaymentPage.__proto__ || Object.getPrototypeOf(PaymentPage)).call(this));

        _this.onPeriodSwitch = function () {
            var period = void 0;
            if (_this.state.period === 'M') {
                period = 'Y';
            } else {
                period = 'M';
            }
            _this.setState({ period: period });
        };

        _this.state = {
            period: p.planData.period
        };
        return _this;
    }

    _createClass(PaymentPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _logger2['default'].track('PaymentPage.load');
        }
    }, {
        key: 'render',
        value: function render() {

            var planName = this.props.planData.name;

            return _react2['default'].createElement(
                'div',
                { className: 'm-payment-page' },
                _react2['default'].createElement(_logoOnlyHeader2['default'], null),
                _react2['default'].createElement(_titleArea2['default'], _extends({ period: this.state.period, onPeriodSwitch: this.onPeriodSwitch }, this.props)),
                _react2['default'].createElement(
                    'div',
                    { className: 'main-area' },
                    _react2['default'].createElement(CtaArea, _extends({}, this.props, { period: this.state.period })),
                    _react2['default'].createElement(_featureArea2['default'], { planName: planName })
                ),
                _react2['default'].createElement(_stripeSecurityCallout2['default'], null),
                _react2['default'].createElement(_captiveFooter2['default'], null)
            );
        }
    }]);

    return PaymentPage;
}(_react.Component);

module.exports = PaymentPage;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/index.jsx
 ** module id = 1087
 ** module chunks = 0
 **/